import Session from 'Faster/model/Session';
import FasterRequest from 'Faster/network/FasterRequest';
import ServerDate from 'Faster/model/ServerDate';

class CloseSessionRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_POST;
  private localTimestamp: Date;
  private ntpLocalTimestamp: Date;
  private session: Session;

  public constructor(session: Session, localTimestamp: Date) {
    this.session = session;
    this.localTimestamp = localTimestamp;
    this.ntpLocalTimestamp = ServerDate.now();
  }

  public body(): object {
    return {
      sessionId: this.session.id,
      localTimestamp: this.localTimestamp,
      ntpLocalTimestamp: this.ntpLocalTimestamp,
    };
  }

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint = (): string => '/v1/session/' + this.session.id + '/close';

  public query = (): string => '';
}

export default CloseSessionRequest;
